import React from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import { FormatStrikethrough, Superscript, Subscript, InsertLink } from '@mui/icons-material';
import { LuHeading1, LuHeading2, LuHeading3 } from 'react-icons/lu';

export type MuiIconName =
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strikethrough'
  | 'superscript'
  | 'subscript'
  | 'headingOne'
  | 'headingTwo'
  | 'headingThree'
  | 'orderedList'
  | 'unorderedList'
  | 'alignLeft'
  | 'alignCenter'
  | 'alignRight'
  | 'link';

interface MuiIconProps extends SvgIconProps {
  icon: MuiIconName;
}

const MuiIcon: React.FC<MuiIconProps> = ({ icon, ...props }) => {
  const iconStyle = {
    fontSize: 'inherit',
    color: 'inherit',
    ...props.style,
  };

  switch (icon) {
    case 'bold':
      return <FormatBoldIcon {...props} />;
    case 'italic':
      return <FormatItalicIcon {...props} />;
    case 'underline':
      return <FormatUnderlinedIcon {...props} />;
    case 'strikethrough':
      return <FormatStrikethrough {...props} />;
    case 'superscript':
      return <Superscript {...props} />;
    case 'subscript':
      return <Subscript {...props} />;
    case 'headingOne':
      return <LuHeading1 style={{ fontSize: '20px', ...props.style }} />;
    case 'headingTwo':
      return <LuHeading2 style={{ fontSize: '20px', ...props.style }} />;
    case 'headingThree':
      return <LuHeading3 style={{ fontSize: '20px', ...props.style }} />;
    case 'orderedList':
      return <FormatListNumberedIcon {...props} />;
    case 'unorderedList':
      return <FormatListBulletedIcon {...props} />;
    case 'alignLeft':
      return <FormatAlignLeftIcon {...props} />;
    case 'alignCenter':
      return <FormatAlignCenterIcon {...props} />;
    case 'alignRight':
      return <FormatAlignRightIcon {...props} />;
    case 'link':
      return <InsertLink {...props} />;
    default:
      return null;
  }
};

export default MuiIcon;
